import { useEffect } from "react";

// Link curto /avaliar → redireciona para a página-ponte do backend, que força a
// abertura no navegador do sistema (fora do navegador interno do WhatsApp).
export default function ReviewRedirect() {
  useEffect(() => {
    const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
    window.location.replace(`${base}/api/public/review`);
  }, []);
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0b0b0f", color: "#fff", fontFamily: "system-ui, sans-serif" }}>
      <p>Abrindo a página de avaliação…</p>
    </div>
  );
}
